import z from 'zod'
import { paxtonHighlightAreaSchema } from '@/components/react-pdf-viewer/schema/paxton-highlight-area'
import { MedSummarySourceRefSchema } from '@/medical-billing-summaries/sources/schemas'

export const MedSummaryReferenceSchema = z.object({
  id: z.string().uuid(),
  file_path: z.string(),
  source: MedSummarySourceRefSchema,
  pages: z.array(z.number().int().nonnegative()),
  highlights: z.array(paxtonHighlightAreaSchema),
})

export type MedSummaryReference = z.infer<typeof MedSummaryReferenceSchema>
